export interface TutorialEntry {
  toolId: string;
  toolLabel: string;
  videoUrl: string;
}

export const TUTORIAL_CONFIG: Record<string, TutorialEntry> = {
  "/optimizer": {
    toolId: "optimizer",
    toolLabel: "Optimizer",
    videoUrl: "https://www.youtube.com/watch?v=Nemsb2fE4Fo",
  },
  "/optimizer/props": {
    toolId: "fantasy-props-optimizer",
    toolLabel: "Fantasy Props",
    videoUrl: "https://www.youtube.com/watch?v=owox0sEVRhU",
  },
  "/whale-watch": {
    toolId: "whale-watch",
    toolLabel: "Whale Watch",
    videoUrl: "https://youtu.be/KrXCHw_7Aew",
  },
  "/low-hold": {
    toolId: "low-hold",
    toolLabel: "Low Hold",
    videoUrl: "https://www.youtube.com/watch?v=pAmSkfzPx8g&t=314s",
  },
  "/prop-discrepancies": {
    toolId: "esports-discrepancies",
    toolLabel: "Prop Discrepancies",
    videoUrl: "https://www.youtube.com/watch?v=TE0hMUAZeOQ",
  },
  "/ev-sniper": {
    toolId: "ev-sniper",
    toolLabel: "EV Sniper",
    videoUrl: "https://www.youtube.com/watch?v=L_6u3WL3t7g",
  },
};
